import { useRef } from 'react';
import { useButton } from 'react-aria';
import { useIntl } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';
import MapTabs from 'client/pages/MapPage/components/MapMenu/MapTabs/MapTabs';
import Icon from '@mdi/react';
import { mdiChevronLeft } from '@mdi/js';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';
import PropTypes from 'prop-types';
import { setMenuOpen } from 'client/store/mapSlice/mapSlice';
import styles from 'client/pages/MapPage/components/MapMenu/MapMenu.module.scss';

const MapMenu = ({ filterKey, selectedAssetOwners, ...props }) => {
    const intl = useIntl();
    const ref = useRef();
    const open = useSelector(state => state?.map?.menuOpen);
    const dispatch = useDispatch();
    const setOpen = open => dispatch(setMenuOpen(open));
    const handleOpen = () => {
        setOpen(!open);
    };

    const { buttonProps } = useButton({
        ...props,
        elementType: 'span',
        onPress: handleOpen
    }, ref);

    return (
        <div
            ref={ref}
            data-testid="mapMenu"
            id="mapMenu"
            className={[styles.menu, open ? null : styles.closed].join(' ')}
        >
            <div className={styles.body}>
                <MapTabs filterKey={filterKey} selectedAssetOwners={selectedAssetOwners}/>
            </div>
            <button
                {...buttonProps}
                type="button"
                className={styles.closeBtn}
                aria-label={intl.formatMessage({ id: 'mapMenu.button.ariaLabel' })}
                aria-controls="mapMenu"
                aria-expanded={open ? 'true' : 'false'}
                data-testid="mapMenu.button"
            >
                <Icon path={mdiChevronLeft} size={2} rotate={open ? 0 : 180}/>
            </button>
        </div>
    );
};

MapMenu.propTypes = {
    ...defaultAriaProps,
    filterKey: PropTypes.string
};

export default MapMenu;
